import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    ApplicationConfig,
    inject,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { ApiModule } from '@api/src/api.module';
import { errorInterceptor } from '@core/error/error-interceptor';
import { LanguageState } from '@core/localization/language.state';
import { defaultLocalizationConfig, LOCALIZATION_CONFIG } from '@core/localization/localization.config';
import { RouteTitleService } from '@core/router/route-title.service';
import { UserState } from '@core/user/user.state';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SnackBarService } from '@shared/components/snack-bar/snack-bar.service';
import { DateFormatService } from '@shared/services/date-format.service';
import { MatDialogService } from '@shared/services/mat-dialog.service';
import { AppState } from '@shared/state/app.state';
import { enUS } from 'date-fns/locale';
import { provideDateFnsAdapter } from 'ngx-material-date-fns-adapter';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig } from 'ngx-webstorage';
import { routes } from './app.routes';
import { authTokenInterceptor } from './features/auth/interceptors/auth-token-interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALIZATION_CONFIG, useValue: defaultLocalizationConfig },
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideDateFnsAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: enUS },
        provideHttpClient(withInterceptors([authTokenInterceptor, errorInterceptor])),
        provideNgxWebstorage(withNgxWebstorageConfig({ prefix: 'agentWebClient' }), withLocalStorage()),
        provideAppInitializer(() => {
            const userState: UserState = inject(UserState);
            const languageState: LanguageState = inject(LanguageState);
            const appState: AppState = inject(AppState);

            appState.loadAppConfig();
            languageState.requestLanguages();
            userState.requestMe();
        }),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/i18n/',
                suffix: '.json',
            }),
        }),
        MatDialogService,
        SnackBarService,
        ApiModule,
        DateFormatService,
        RouteTitleService,
    ],
};
